/*@jsxRuntime classic @jsx React.createElement @jsxFrag React.Fragment*/
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import React from "react";
import TriggerPayload, {CLOUD_DEVICE_TRIGGER_INFO, getExecutionPayloadObject} from '@components/TriggerPayload';
function _createMdxContent(props) {
  const _components = Object.assign({
    h1: "h1",
    a: "a",
    span: "span",
    p: "p",
    img: "img",
    h2: "h2",
    ul: "ul",
    li: "li"
  }, _provideComponents(), props.components);
  return React.createElement(React.Fragment, null, React.createElement(_components.h1, {
    id: "job-timeout-trigger",
    style: {
      position: "relative"
    }
  }, React.createElement(_components.a, {
    href: "#job-timeout-trigger",
    "aria-label": "job timeout trigger permalink",
    className: "anchor before"
  }, React.createElement(_components.span, {
    dangerouslySetInnerHTML: {
      __html: "<svg aria-hidden=\"true\" focusable=\"false\" height=\"16\" version=\"1.1\" viewBox=\"0 0 16 16\" width=\"16\"><path fill-rule=\"evenodd\" d=\"M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z\"></path></svg>"
    }
  })), "Job: Timeout Trigger"), "\n", React.createElement(_components.p, null, "The Job: Iteration Timeout Trigger fires a workflow whenever an iteration of a Resource Job is not acknowledged before the Resource Job’s configured timeout."), "\n", React.createElement(_components.img, {
    src: "/images/workflows/triggers/job-iteration-timeout-trigger.png",
    alt: "Job: Timeout Trigger",
    title: "Job: Timeout Trigger"
  }), "\n", React.createElement(_components.h2, {
    id: "node-properties",
    style: {
      position: "relative"
    }
  }, React.createElement(_components.a, {
    href: "#node-properties",
    "aria-label": "node properties permalink",
    className: "anchor before"
  }, React.createElement(_components.span, {
    dangerouslySetInnerHTML: {
      __html: "<svg aria-hidden=\"true\" focusable=\"false\" height=\"16\" version=\"1.1\" viewBox=\"0 0 16 16\" width=\"16\"><path fill-rule=\"evenodd\" d=\"M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z\"></path></svg>"
    }
  })), "Node Properties"), "\n", React.createElement(_components.p, null, "The Job: Timeout Trigger has one piece of configuration: the Resource Job, which will fire this trigger when an iteration times out."), "\n", React.createElement(_components.h2, {
    id: "payload",
    style: {
      position: "relative"
    }
  }, React.createElement(_components.a, {
    href: "#payload",
    "aria-label": "payload permalink",
    className: "anchor before"
  }, React.createElement(_components.span, {
    dangerouslySetInnerHTML: {
      __html: "<svg aria-hidden=\"true\" focusable=\"false\" height=\"16\" version=\"1.1\" viewBox=\"0 0 16 16\" width=\"16\"><path fill-rule=\"evenodd\" d=\"M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z\"></path></svg>"
    }
  })), "Payload"), "\n", React.createElement(_components.p, null, "The payload will include the triggering event in the ", React.createElement(_components.span, {
    dangerouslySetInnerHTML: {
      __html: "<code class=\"language-text\">data</code>"
    }
  }), " field. In the general case, a Job: Timeout workflow payload will look like the following:"), "\n", React.createElement(TriggerPayload, {
    flowClass: "cloud",
    payload: {
      data: {
        accumulator: '{\"example\":900001}',
        device: CLOUD_DEVICE_TRIGGER_INFO,
        execution: getExecutionPayloadObject({
          status: 'inProgress'
        }),
        iterationId: '444444444444dddddddddddd-111111111111aaaaaaaaaaaa',
        iterationStartedAt: 'DATE_OBJECT'
      },
      relayId: '<ID of the job>',
      relayType: 'resourceJob',
      triggerId: '<ID of the job>',
      triggerType: 'resourceJobIterationTimeout'
    }
  }), "\n", React.createElement(_components.h2, {
    id: "related-nodes",
    style: {
      position: "relative"
    }
  }, React.createElement(_components.a, {
    href: "#related-nodes",
    "aria-label": "related nodes permalink",
    className: "anchor before"
  }, React.createElement(_components.span, {
    dangerouslySetInnerHTML: {
      __html: "<svg aria-hidden=\"true\" focusable=\"false\" height=\"16\" version=\"1.1\" viewBox=\"0 0 16 16\" width=\"16\"><path fill-rule=\"evenodd\" d=\"M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z\"></path></svg>"
    }
  })), "Related Nodes"), "\n", React.createElement(_components.ul, null, "\n", React.createElement(_components.li, null, React.createElement(_components.a, {
    href: "/workflows/triggers/job-complete/"
  }, "Job: Complete Trigger")), "\n", React.createElement(_components.li, null, React.createElement(_components.a, {
    href: "/workflows/triggers/job-iteration/"
  }, "Job: Iteration Trigger")), "\n", React.createElement(_components.li, null, React.createElement(_components.a, {
    href: "/workflows/outputs/job-acknowledge/"
  }, "Job: Acknowledge Output Node")), "\n", React.createElement(_components.li, null, React.createElement(_components.a, {
    href: "/workflows/outputs/job-execute/"
  }, "Job: Execute Output Node")), "\n"));
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? React.createElement(MDXLayout, props, React.createElement(_createMdxContent, props)) : _createMdxContent(props);
}
export default MDXContent;
